<template>
  <v-row class="mt-4 mb-3">
    <v-col sm="12" class="pa-0">
      <v-card height="100%" width="100%" tile>
        <YandexMaps :zoom="13" :coordinates="[this.latitude, this.longitude]"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import YandexMaps from "@/components/YandexMaps";
import Coordinates from "coordinate-parser"

export default {
  name: "MapComponent",
  components: {YandexMaps},
  data() {
    return {
      latitude: this.coords.latitude,
      longitude: this.coords.longitude,
      position: undefined,
    }
  },
  props: {
    coords: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    }
  },

  created() {
    this.position = new Coordinates(this.latitude + " " + this.longitude)
    this.latitude = this.position.getLatitude()
    this.longitude = this.position.getLongitude()
  }
}
</script>

<style scoped>
.ymap-container {
  margin: 0;
  height: 70vh;
  width: 100%;
}
</style>